/**
 * Versionamento
 * 
 * - 1.00 - em 23/04/2025
 *  - Versão Inicial
 * 
 */

import { DateTime } from "luxon";

export const DTFORMAT = Object.freeze( {
  USUARIO: 'dd/MM/yyyy',
  USUARIO_DATETIME: 'dd/MM/yyyy HH:mm:ss',
  BANCO: 'yyyy-MM-dd',
  BANCO_DATETIME: 'yyyy-MM-dd HH:mm:ss',
  UTC: 'yyyy-MM-ddTHH:mm:ssZ'
} )

export default class ClsFormatacao {

  public fromMills ( dateTimeJS: number, formato: string ): string {
    return DateTime.fromMillis( dateTimeJS ).toFormat( formato )
  }

  public telefone ( numero: string ): null | string {

    let cleaned = ( "" + numero ).replace( /\D/g, "" );

    let mascara: RegExp =
      cleaned.length === 11 ?
        /^(\d{0,2})?(\d{0,5})?(\d{0,4})?$/ :
        /^(\d{0,2})?(\d{0,4})?(\d{0,4})?$/

    let match = cleaned.match( mascara );

    if ( match && [10, 11].includes( cleaned.length ) ) {

      return [
        match[1] ? "(" : "",
        match[1],
        match[1] ? ") " : "",
        match[2],
        match[3] ? "-" : "",
        match[3],
      ].join( "" );

    } else {

      return null

    }

  }

  public cpf ( numero: string ): null | string {

    let cleaned = ( "" + numero ).replace( /\D/g, "" );

    let mascara: RegExp =
      /^(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,2})?$/

    let match = cleaned.match( mascara );

    if ( match && [11].includes( cleaned.length ) ) {

      return [
        match[1],
        match[2] ? "." : "",
        match[2],
        match[3] ? "." : "",
        match[3],
        match[4] ? "-" : "",
        match[4],
      ].join( "" );

    } else {

      return null

    }

  }

  public currency ( numero: number, casasDecimais: number = 2 ): string {
    return numero.toLocaleString( 'pt-br', { maximumFractionDigits: casasDecimais, minimumFractionDigits: casasDecimais } )
  }

  public numeroAmostra ( numero: string ): null | string {

    let cleaned = ( "" + numero ).replace( /\D/g, "" );

    let mascara: RegExp =
      /^(\d{0,2})?(\d{0,2})?(\d{0,5})?$/

    let match = cleaned.match( mascara );

    if ( match && cleaned.length === 9 ) {

      return [
        match[1],
        ".",
        match[2],
        ".",
        match[3]
      ].join( "" );

    } else {

      return null

    }

  }

  /** Converte yyyy-MM-dd para dd/MM/yyyy */
  public dataISOtoUser ( data: string ): string {
    return DateTime.fromFormat( data, 'yyyy-MM-dd' ).toFormat( 'dd/MM/yyyy' )
  }

  public dataMillsToUser ( data: number ): string {
    return DateTime.fromMillis( data ).toFormat( 'dd/MM/yyyy' )
  }
  public dataAbreviadaParaDataCompleta ( dataAbreviada: string ): string {
    return dataAbreviada.concat( '/' ).concat( DateTime.now().toFormat( 'yyyy' ) )
  }

  public dateParaDateTimeUser ( data: Date ): string {
    return DateTime.fromJSDate( data ).toFormat( 'dd/MM/yyyy HH:SS' )
  }

  public dateParaDateUser ( data: Date ): string {
    return DateTime.fromJSDate( data ).toFormat( 'dd/MM/yyyy' )
  }

  public dateParaDateSQL ( data: Date ): string {
    return DateTime.fromJSDate( data ).toFormat( 'yyyy-MM-dd' )
  }

  public dataFromIsoUTC ( data: string, formato: string = DTFORMAT.USUARIO_DATETIME ): string {
    return DateTime.fromISO( data, { zone: 'utc' } ).toFormat( formato )
  }

  /**
 * Converte um valor no formato BR (com vírgula) para US (javascritp) - Converte somente se a origem for string....
 * @param valor 
 * @returns 
 */

  public nBRtoUS ( valorString: string ): number {
    let retorno: number = 0

    retorno = parseFloat( valorString.replace( /\./g, '' ).replace( ',', '.' ) )

    return Number.isNaN( retorno ) ? 0 : retorno

  }

  public primeiraPalavra ( texto: string ) {
    const padrao = /\b\w+\b/;
    const correspondencia = texto.match( padrao );

    if ( correspondencia ) {
      return correspondencia[0];
    } else {
      return '';
    }
  }

  public somenteNumeros ( numero: string ): string {
    return numero.replace( /\D/g, "" );
  }
}